import { COMMUNITY_BASE_URL } from '../../constants/endpoint'
import { ICompetenceArea, ICounty, IMunicipality, IProfileUser } from '../models/profile.model'

export async function getAllCounties(): Promise<ICounty[]> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/counties`)

  const jsonResults = await response.json()
  return <ICounty[]>jsonResults
}

export async function getMunicipalitiesByCounty(countyId: string): Promise<IMunicipality[]> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/municipalities?countyId=${parseInt(countyId)}`)

  const jsonResults = await response.json()
  return <IMunicipality[]>jsonResults
}

export async function getCompetenceAreas(): Promise<ICompetenceArea[]> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/competenceareas`)

  const jsonResults = await response.json()
  return <ICompetenceArea[]>jsonResults
}

export async function getUserInfo(userId: number): Promise<IProfileUser> {
  let response = await fetch(`${COMMUNITY_BASE_URL}/users/${userId}`)

  const jsonResults = await response.json()
  return <IProfileUser>jsonResults
}

export async function updateUser(
  token: string,
  userId: number,
  firstname: string,
  lastname: string,
  phone: string,
  authority: string,
  title: string,
  county: number,
  municipalities: number[],
  competenceAreas: number[],
  mobilePhone: string,
  postalAddress: string,
  email: string,
) {
  const bodyWorkroomPost = JSON.stringify({
    Firstname: firstname,
    Lastname: lastname,
    Phone: phone,
    Authority: authority,
    Title: title,
    CountyId: county,
    MunicipalityIds: municipalities,
    CompetenceAreaIds: competenceAreas,
    MobilePhone: mobilePhone,
    PostalAddress: postalAddress,
    Email: email,
  })

  await fetch(`${COMMUNITY_BASE_URL}/users/${userId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': token,
    },
    body: bodyWorkroomPost,
  })
  return
}

export async function saveProfileImage(token: string, userId: number, image: any) {
  if (!image) return

  const formData = new FormData()
  formData.append('file', image)
  await fetch(`${COMMUNITY_BASE_URL}/users/${userId}/profileImage`, {
    method: 'POST',
    headers: {
      'X-CSRF-TOKEN': token,
    },
    body: formData,
  })
  return
}
